const defaultLexicon = Object.freeze({
  organization: 'Default',
  core: 'Core',
  choice: 'Choice',
  journey: 'Journey',
  level: 'Level',
  course: 'Course',
  resource: 'Resource',
  checkin: 'Check-in',
  engagement: 'Engagement',
  section: 'Section',
  // "Activity" Terms
  activity: 'Activity',
  activity_course: 'Activity Course',
  //"Quest" Terms
  quest: 'Quest',
  quest_goal: 'Quest Goal',
  // "Artifact" Terms
  artifact: 'Artifact',
  artifact_assessment: 'Artifact Assessment',
  // "Skills" Terms
  skill: 'Skill',
  skills_check: 'Skill Check',
  focus_skill: 'Focus Skill',
  // "Term" Terms
  term: 'Term',
  term_report: 'Term Report',
  // "Mentor" Terms
  mentor: 'Mentor',
  mentor_guidance: 'Mentor Guidance',
  mentor_prep: 'Mentor Prep'
})

export default defaultLexicon
